import { PersonType } from 'src/app/services/models/enums';
import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from "rxjs";

@Component({
    selector: 'app-bar-chart',
    templateUrl: './bar-chart.component.html',
    styleUrls: ['./bar-chart.component.scss'],
    standalone: false
})
export class BarChartComponent implements OnInit {

  @Input()
  public valueForBarChart;

  @Input()
  public doTransformData: boolean;

  @Input()
  public deudaOrMora = false;

  private monthsPerYear = [
    { id: '01', value: $localize`ene` },
    { id: '02', value: $localize`feb` },
    { id: '03', value: $localize`mar` },
    { id: '04', value: $localize`abr` },
    { id: '05', value: $localize`may` },
    { id: '06', value: $localize`jun` },
    { id: '07', value: $localize`jul` },
    { id: '08', value: $localize`ago` },
    { id: '09', value: $localize`sep` },
    { id: '10', value: $localize`oct` },
    { id: '11', value: $localize`nov` },
    { id: '12', value: $localize`dic` }
  ]
  rangeData: any[] = [];
  rangeLabels: string[] = [];
  ip = false;
  isLoading = true;
  cachedLabels: string[] = [];
  cachedRangeData: { label: string; data: any; __labels: string[]; }[];
  cachedQuery: any;
  subscriptions: Subscription[] = [];
  personType: PersonType;

  // se fueron al dashboard
  indicators = [
    { name: "Score", value: "score" },
    { name: "Income Predictor", value: "ip" },
    { name: "Antigüedad", value: $localize`antiguedad` },
    { name: "Deuda Vencida", value: $localize`deudaTotalSg` },
    { name: "Cant. de Moras", value: $localize`deudaTotalCg` }
  ]
  objectQueryIndicator;
  indicatorSelected: string = null;

  constructor() { 
    // Empty Constructor 
  }

  ngOnInit() {
    // this method is not implemented
   }

  ngOnChanges() {
    this.isLoading = false;
    this.getRangeData(this.valueForBarChart)
    this.indicatorSelected = "Score";
  }

  async getRangeData(res) {
    this.isLoading = false;
    this.rangeData = [];
    this.rangeLabels = [];
    if (!!res) {
      if (res[0].indicatorName == "ip")
        this.ip = true;
      else {
        this.ip = false; 
      }
      res.sort((a, b) => {
        const A_LABEL_ARR = a.periodString.split("-");
        const B_LABEL_ARR = b.periodString.split("-");
        return Number(A_LABEL_ARR[1]) - Number(B_LABEL_ARR[1]);
      })
      res.sort((a, b) => {
        const A_LABEL_ARR = a.periodString.split("-");
        const B_LABEL_ARR = b.periodString.split("-");
        return Number(A_LABEL_ARR[0]) - Number(B_LABEL_ARR[0]);
      })
      this.rangeLabels = res.map(period => period.periodString);
      /*[{ 2018-01, 2018-02, 2018-03, ....., now - (1 month)
        data: [ count , count  , count  , ....., count          ]
        label: range }]*/
      let rangeTemporary = [];
      this.rangeLabels.forEach((a) => {
        const A_Period = a.split("-");
        let value;
        this.monthsPerYear.forEach((m) => {
          if (m.id === A_Period[1])
            value = m.value;
        })
        rangeTemporary.push(value + "-" + A_Period[0])
          ;
      })
      this.rangeLabels = rangeTemporary;
      let allRanges: any = {};
      res.forEach(period => {
        Object.keys(period.rangeValues).forEach(range => {
          allRanges[range] = null;
        })
      })
      this.rangeData = Object.entries(
        res.reduce(
          (accum, period) => {
            Object.keys(allRanges).forEach(range => {
              accum[range] = accum[range] || [];
              accum[range].push(Math.abs(period.rangeValues[range]) || 0)
            })
            return accum;
          }, {}))
        .map(
          ([range, valuesPerPeriod]) => (
            {
              label: range,
              data: valuesPerPeriod,
              __labels: this.cachedLabels
            }))
        .sort(
          (a, b) => {
            const A_LABEL_ARR = a.label.split("-");
            const B_LABEL_ARR = b.label.split("-");
            return Number(A_LABEL_ARR[0]) - Number(B_LABEL_ARR[0]);
          })
      this.isLoading = false;
    } else {
      this.rangeData = [];
      this.rangeLabels = [];
    }
  }

}
